// re.rejouis.fr — PANIER de reprise. Liste des jouets estimés, total, note
// « définitif après vérification », mention Mondial Relay, validation.
// Lot (2026-10-13) : une ligne du panier sans montant — offre de l'atelier sous
// 14 jours, étiquette envoyée après la réponse du client (AvertissementLot).
import { EcranHeader, Icons, Thumb, Sticker, Parcours, PastilleBoost, PrixBarre, LARGEUR_MAX } from '../components/ui.jsx';
import { fmtEuro } from '../lib/format.js';
import { suivre } from '../lib/posthog.js';
import { repartition, libelleTotaux } from '../lib/rachat.js';

export default function Panier({ go, panier, onRetirer, onModifier }) {
  const total = panier.reduce((s, l) => s + (l.credit || 0), 0);
  const lot = panier.find((l) => l.lot) || null;
  const nbJouets = panier.reduce((s, l) => s + (l.lot ? l.quantite || 0 : 1), 0);

  // Rachat en euros : le paiement a été choisi jouet par jouet à l'écran État (figé ici :
  // pour changer, on retire le jouet et on recommence). L'IBAN est demandé à l'étape Vérifications.
  const rep = repartition(panier);
  const avecVir = rep.virement > 0;
  const libelleTotal = avecVir ? libelleTotaux(rep, fmtEuro) : fmtEuro(total);

  if (!panier.length) {
    return (
      <div className="no-scrollbar" style={{ height: '100%', overflow: 'auto', padding: '16px 0 40px' }}>
        <EcranHeader titre="Mon panier" onBack={() => go('accueil')} />
        <div style={{ padding: '60px 22px 0', textAlign: 'center' }}>
          <div style={{ display: 'flex', justifyContent: 'center' }}><Sticker nom="boite" size={110} anim="pop" /></div>
          <h2 className="t-display" style={{ fontSize: 24, margin: '14px 0 0' }}>Ton panier est vide</h2>
          <p style={{ fontSize: 13.5, color: 'var(--stone)', margin: '8px 0 18px', lineHeight: 1.6 }}>
            Cherche un modèle ou prends-le en photo, on t’estime ton crédit en quelques secondes.
          </p>
          <button className="btn btn-primary btn-block" onClick={() => go('catalogue', { focus: true })}>Chercher un modèle</button>
        </div>
      </div>
    );
  }

  return (
    <div className="no-scrollbar" style={{ height: '100%', overflow: 'auto', padding: '16px 0 150px' }}>
      <EcranHeader titre="Mon panier" onBack={() => go('catalogue', { focus: true })} />
      <Parcours etape={1} />

      <div style={{ padding: '4px 16px 0', display: 'flex', flexDirection: 'column', gap: 8 }}>
        {panier.map((l) => (
          <div key={l.ligneId || l.produitId} className="card" style={{ display: 'flex', alignItems: 'center', gap: 12, padding: 12 }}>
            <Thumb produit={l} />
            <div style={{ flex: 1, minWidth: 0 }}>
              <div style={{ fontWeight: 700, fontSize: 13.5, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{l.titre}</div>
              <div style={{ fontSize: 11.5, color: 'var(--stone)', marginTop: 1 }}>
                {l.lot ? 'Estimé à la main par notre atelier'
                  : <>{l.etatDeclare}{l.accessoiresIncomplets ? ' · accessoires manquants' : ''}</>}
              </div>
              {/* Virement choisi : figé, on retire le jouet pour changer (décision Benoni 2026-10-28). */}
              {l.paiement === 'virement' ? null : (
                <button onClick={() => onModifier(l)}
                  style={{ display: 'inline-flex', alignItems: 'center', gap: 4, marginTop: 4, fontSize: 11, fontWeight: 600, color: 'var(--rouge)' }}>
                  <Icons.pencil size={11} /> {l.lot ? 'Modifier le lot' : 'Modifier l’état'}
                </button>
              )}
            </div>
            <div style={{ textAlign: 'right', flexShrink: 0 }}>
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', gap: 6 }}>
                {l.lot ? (
                  <span style={{ fontWeight: 700, fontSize: 12, color: 'var(--stone)', whiteSpace: 'nowrap' }}>Offre sous 14 j</span>
                ) : (
                  l.paiement === 'virement' ? (
                    <span style={{ fontWeight: 700, fontSize: 14, color: 'var(--rouge)', whiteSpace: 'nowrap' }}>{fmtEuro(l.montantVirement)}</span>
                  ) : (
                  <>
                    {l.creditSansBoost && l.creditSansBoost < l.credit ? <PrixBarre montant={l.creditSansBoost} style={{ fontSize: 12 }} /> : null}
                    <span style={{ fontWeight: 700, fontSize: 14, color: 'var(--rouge)', whiteSpace: 'nowrap' }}>{fmtEuro(l.credit)}</span>
                  </>
                  )
                )}
              </div>
              {l.paiement === 'virement'
                ? <div style={{ fontSize: 11, fontWeight: 700, color: 'var(--stone)', marginTop: 2, whiteSpace: 'nowrap' }}>par virement</div>
                : !l.lot && l.boostPrio > 0 ? <div style={{ marginTop: 4 }}><PastilleBoost boost={l.boostPrio} style={{ position: 'relative' }} /></div> : null}
              <button onClick={() => onRetirer(l.ligneId)} aria-label="Retirer"
                style={{ marginTop: 6, color: 'var(--stone)', display: 'inline-flex', alignItems: 'center', gap: 4, fontSize: 11 }}>
                <Icons.trash size={13} /> Retirer
              </button>
            </div>
          </div>
        ))}
      </div>

      {lot ? <div style={{ padding: '12px 16px 0' }}><AvertissementLot /></div> : null}

      <div style={{ padding: '16px 16px 0', display: 'flex', flexDirection: 'column', gap: 8 }}>
        {!lot ? (
          <button onClick={() => go('lot')} className="rep-btn" style={{ justifyContent: 'center', minHeight: 44, color: 'var(--stone)', borderStyle: 'dashed' }}>
            <Icons.plus size={15} /> Ajouter un lot de jouets sans référence
          </button>
        ) : null}
        <button onClick={() => go('catalogue', { focus: true })} className="rep-btn" style={{ justifyContent: 'center', minHeight: 48, color: 'var(--rouge)', borderStyle: 'dashed' }}>
          <Icons.plus size={16} /> Ajouter un autre jouet
        </button>
      </div>


      {/* Total + mentions */}
      <div style={{ padding: '18px 16px 0' }}>
        <div className="card" style={{ padding: 16 }}>
          <div style={{ display: 'flex', alignItems: 'baseline', justifyContent: 'space-between' }}>
            <span style={{ fontSize: 13, color: 'var(--stone)' }}>{nbJouets} jouet{nbJouets > 1 ? 's' : ''}</span>
            {avecVir ? null : <span className="t-display" style={{ fontSize: 30, color: 'var(--rouge)' }}>{fmtEuro(total)}</span>}
          </div>
          {avecVir ? (
            <div style={{ display: 'flex', flexDirection: 'column', gap: 2, marginTop: 6 }}>
              {rep.bon > 0 ? (
                <div style={{ display: 'flex', alignItems: 'baseline', justifyContent: 'space-between' }}>
                  <span style={{ fontSize: 13, color: 'var(--stone)' }}>Total en bon d’achat</span>
                  <span className="t-display" style={{ fontSize: 24, color: 'var(--rouge)' }}>{fmtEuro(rep.bon)}</span>
                </div>
              ) : null}
              <div style={{ display: 'flex', alignItems: 'baseline', justifyContent: 'space-between' }}>
                <span style={{ fontSize: 13, color: 'var(--stone)' }}>Total par virement</span>
                <span className="t-display" style={{ fontSize: 24, color: 'var(--rouge)' }}>{fmtEuro(rep.virement)}</span>
              </div>
            </div>
          ) : null}
          {lot ? (
            <div style={{ textAlign: 'right', fontSize: 12, color: 'var(--stone)', marginTop: 2 }}>+ l’offre pour ton lot, sous 14 jours</div>
          ) : null}
          <div style={{ display: 'flex', gap: 8, marginTop: 12, fontSize: 11.5, color: 'var(--stone)', lineHeight: 1.5, alignItems: 'flex-start' }}>
            <Icons.info size={14} style={{ flexShrink: 0, marginTop: 1 }} />
            {avecVir
              ? `Montant garanti pour chaque jouet conforme à ta déclaration. On vérifie tout au labo : le virement part après la vérification${rep.bon > 0 ? ', le bon d’achat arrive 2 jours après réception' : ''}.`
              : 'Crédit garanti pour chaque jouet conforme à ta déclaration. On vérifie tout au labo : le crédit arrive 2 jours après réception.'}
          </div>
          <div style={{ display: 'flex', gap: 8, marginTop: 10, fontSize: 12, color: 'var(--mint-fonce)', fontWeight: 600, alignItems: 'center' }}>
            <Icons.truck size={15} /> Envoi offert via Mondial Relay
          </div>
        </div>
      </div>

      {/* Barre de validation fixe */}
      <div style={{ position: 'fixed', left: 0, right: 0, bottom: 0, padding: '12px 16px 22px', zIndex: 30, maxWidth: LARGEUR_MAX, margin: '0 auto',
        background: 'linear-gradient(to top, var(--blanc) 78%, transparent)' }}>
        <button className="btn btn-primary btn-block" onClick={() => {
          const checkoutDetails = {
            item_count: nbJouets,
            basket_total_credit: total,
            includes_lot: Boolean(lot),
            payout: avecVir ? (rep.bon > 0 ? 'mixte' : 'virement') : 'bon_achat',
          };
          suivre('checkout_started', checkoutDetails);
          go('verifications');
        }}>
          Valider ma demande · {libelleTotal}{lot ? ' + lot' : ''}
        </button>
      </div>
    </div>
  );
}

// Avertissement affiché dès qu'un lot est dans le panier (décision Benoni 2026-10-13).
// Court et visible : le délai et ce que le client fera ensuite.
// `grand` : version mise en avant en haut de l'écran Vérifications.
export function AvertissementLot({ grand = false }) {
  return (
    <div style={{ padding: grand ? '16px 16px' : '12px 14px', borderRadius: 14, background: 'var(--jaune-pale)',
      border: grand ? '2px solid var(--jaune)' : 'none', color: 'var(--encre)' }}>
      <div style={{ display: 'flex', gap: 10, alignItems: 'center' }}>
        <Icons.info size={grand ? 22 : 16} style={{ flexShrink: 0, color: 'var(--rouge)' }} />
        <div style={{ fontWeight: 800, fontSize: grand ? 16 : 13.5, lineHeight: 1.3 }}>
          Ton lot : offre sous 14 jours
        </div>
      </div>
      <div style={{ fontSize: grand ? 13.5 : 12.5, lineHeight: 1.55, marginTop: 6 }}>
        N’envoie rien tout de suite. Tu acceptes l’offre ou tu retires le lot, puis tu reçois ton étiquette pour un seul colis.
      </div>
    </div>
  );
}
